{
  "de": {
    "courseBookmark": {
      "title": "Gemerkte Fortbildungen",
      "emptyState": {
        "title": "Deine Merkliste ist noch leer",
        "body": "Du hast dir noch keine Fortbildungen gemerkt. Du kannst Fortbildungen, die dir gefallen auf die Merkliste setzen. Dazu musst du einfach das <i class='bi bi-heart text-primary'></i> anklicken."
      },
      "links": {
        "toCourses": "Fortbildungen entdecken"
      }
    }
  }
}
